import { render, staticRenderFns } from "./FormDesign.vue?vue&type=template&id=0631f1e5&scoped=true&"
import script from "./FormDesign.vue?vue&type=script&lang=js&"
export * from "./FormDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0631f1e5",
  null
  
)

export default component.exports